import moment from 'moment';
import capitalize from 'lodash/capitalize';
import { config } from 'env_def';
import cloneDeep from 'lodash/cloneDeep';
import dayjs from 'dayjs';
import { mailBoxOfDeleted, mailBoxOfSpam, mailUnfinishedMailTable, } from './mail_action_store_model';
import { MailModelHandler } from './mail_entry_helper';
import { MailContentHandler } from './mail_content_handler';
import { MailSearchHandler } from './mail_search_handler';
import { api } from '@/api/api';
import { apis, getDingTalkSearchString } from '@/config';
import { locationHelper } from '@/api/util/location_helper';
import { MailAbstractHandler } from './mail_abs_handler';
import { getIn18Text } from '@/api/utils';
import { ErrResult } from '@/api/errMap';
const trackApi = api.requireLogicalApi(apis.dataTrackerApiImp);
export class MailOperationHandler extends MailSearchHandler {
    constructor(actions, modelHandler, contactHandler, mailDbHandler, subActions) {
        super(actions, modelHandler, contactHandler, mailDbHandler, subActions);
        this.defaultStyle = '';
        this.concurrentUpload = 3;
        this.pastingLoopMap = new Map();
        this.dataTracker = api.requireLogicalApi(apis.dataTrackerApiImp);
        this.storeApi = api.getDataStoreApi();
        this.contactApi = api.requireLogicalApi(apis.contactApiImpl);
    }
    async doReplayMail(id, all, noPopup, additionalContent, isThread, _account, config) {
        const { owner, colleagueAccId, isTpMail, mailFrom, type, refId } = config || {};
        let writeId = id;
        if (isThread) {
            writeId = await this.mailDbHanlder.getFirstMessageFromThreadMail(id, _account);
        }
        console.log('[mail] reply mail ' + writeId, all);
        const writeType = all ? 'replyAll' : 'reply';
        const params = {
            id: writeId,
            writeType: writeType,
            mailType: 'common',
            originContent: additionalContent,
            _account,
            owner,
            colleagueAccId,
            isTpMail,
            mailFrom,
            tpType: type,
            tpRefId: refId,
        };
        if (process.env.BUILD_ISWEB && locationHelper.isReadMail()) {
            params.writeWay = 'newWebTab';
        }
        else if (process.env.BUILD_ISELECTRON && locationHelper.isReadMail()) {
            params.writeWay = 'newWin';
        }
        if (!noPopup) {
            return this.callWriteLetterFunc(params);
        }
        return params;
    }
    async doReplayMailWithAttach(id, all, noPopup, additionalContent, _account, config) {
        console.log('[mail] replyWithAttach mail ' + id, all);
        const { owner, colleagueAccId, isTpMail, mailFrom, type, refId } = config || {};
        const writeType = all ? 'replyAllWithAttach' : 'replyWithAttach';
        const params = {
            id,
            writeType: writeType,
            mailType: 'common',
            originContent: additionalContent,
            _account,
            owner,
            colleagueAccId,
            isTpMail,
            mailFrom,
            tpType: type,
            tpRefId: refId,
        };
        if (process.env.BUILD_ISWEB && locationHelper.isReadMail()) {
            params.writeWay = 'newWebTab';
        }
        else if (process.env.BUILD_ISELECTRON && locationHelper.isReadMail()) {
            params.writeWay = 'newWin';
        }
        if (!noPopup) {
            return this.callWriteLetterFunc(params);
        }
        return params;
    }
    async doReplayAllAsNew(id, noPopup, _account) {
        const params = {
            id,
            writeType: 'replyAllAsNew',
            mailType: 'common',
            _account,
        };
        if (process.env.BUILD_ISWEB && locationHelper.isReadMail()) {
            params.writeWay = 'newWebTab';
        }
        else if (process.env.BUILD_ISELECTRON && locationHelper.isReadMail()) {
            params.writeWay = 'newWin';
        }
        if (!noPopup) {
            return this.callWriteLetterFunc(params);
        }
        return params;
    }
    async doForwardMail(id, payload) {
        const { noPopup, additionalContent, isThread, asAttach, asAttachIds, _account, owner, title, contact, colleagueAccId, isTpMail, mailFrom, type, refId } = payload || {};
        let forwardId = id;
        if (isThread && !asAttachIds) {
            forwardId = await this.mailDbHanlder.getFirstMessageFromThreadMail(id, _account);
        }
        console.log('[mail] forward mail ' + forwardId, isThread);
        const writeType = !asAttach ? 'forward' : 'forwardAsAttach';
        const params = {
            id: forwardId,
            asAttachIds,
            writeType: writeType,
            mailType: 'common',
            originContent: additionalContent,
            _account,
            owner,
            colleagueAccId,
            title,
            contact,
            isTpMail,
            mailFrom,
            tpType: type,
            tpRefId: refId,
        };
        if (process.env.BUILD_ISWEB && locationHelper.isReadMail()) {
            params.writeWay = 'newWebTab';
        }
        else if (process.env.BUILD_ISELECTRON && locationHelper.isReadMail()) {
            params.writeWay = 'newWin';
        }
        if (!noPopup) {
            return this.callWriteLetterFunc(params);
        }
        return params;
    }
    async doEditMail(id, payload) {
        const { noPopup, draft, isThread, _account } = payload || {};
        let editId = id;
        if (isThread) {
            editId = await this.mailDbHanlder.getFirstMessageFromThreadMail(id, _account);
        }
        console.log('[mail] edit mail ' + editId, isThread);
        const params = {
            id,
            writeType: draft ? 'editDraft' : 'edit',
            mailType: draft ? 'common' : 'draft',
            _account,
        };
        if (process.env.BUILD_ISWEB && locationHelper.isReadMail()) {
            params.writeWay = 'newWebTab';
        }
        else if (process.env.BUILD_ISELECTRON && locationHelper.isReadMail()) {
            params.writeWay = 'newWin';
        }
        if (!noPopup) {
            return this.callWriteLetterFunc(params);
        }
        return params;
    }
    doExportMailAsEml(mid, fileName, dialogConfirmText, _account) {
        var _a;
        const fullFileName = this.systemApi.isElectron() && window.electronLib ? `${fileName}.eml` : fileName;
        const isSubAccount = this.mailConfApi.isSubAccount(_account);
        const _token = ((_a = this.mailConfApi.accountTokens.find((token) => token.account === _account)) === null || _a === void 0 ? void 0 : _a.token) || '';
        console.log('[mail] mail export as eml ', mid, fullFileName);
        const currentUser = this.systemApi.getCurrentUser(_account);
        let urlBase = this.systemApi.getAccountUrl('mailDownload', _account);
        const req = {
            action: 'download_eml',
            l: 'read',
            mode: 'download',
            sid: (currentUser === null || currentUser === void 0 ? void 0 : currentUser.sessionId) || '',
            mid,
            trigger_type: 'user_click',
        };
        if (isSubAccount && !this.systemApi.isElectron()) {
            req._token = _token;
            urlBase = this.systemApi.getAccountUrl('mailDownloadProxy', _account);
        }
        const url = this.impl.buildUrl(urlBase, req, { _account });
        return this.fileApi.saveDownload({ fileUrl: url, fileName: fullFileName, dialogConfirmText }, { _account, flowScene: 'mail_read' });
    }
    doExportGroupMailAsZip(ids, fileName, dialogConfirmText, _account) {
        var _a;
        const fullFileName = this.systemApi.isElectron() && window.electronLib ? `${fileName}.zip` : fileName;
        const midParams = ids.reduce((total, current) => {
            total += `&mid=${current}`;
            return total;
        }, '');
        console.log('group mail export as zip', midParams);
        const currentUser = this.systemApi.getCurrentUser(_account);
        let urlBase = this.systemApi.getAccountUrl('mailOperation', _account);
        const req = {
            sid: (currentUser === null || currentUser === void 0 ? void 0 : currentUser.sessionId) || '',
            func: 'mbox:packMessages',
            trigger_type: 'user_click',
        };
        if (this.mailConfApi.isSubAccount(_account) && !this.systemApi.isElectron()) {
            const _token = ((_a = this.mailConfApi.accountTokens.find((token) => token.account === _account)) === null || _a === void 0 ? void 0 : _a.token) || '';
            urlBase = '/commonweb/proxy' + urlBase;
            req._token = _token;
        }
        const url = this.impl.buildUrl(urlBase, req, { _account }) + midParams;
        console.log('group mail export as zip', url, fileName);
        return this.fileApi.saveDownload({ fileUrl: url, fileName: fullFileName, dialogConfirmText }, { _account, flowScene: 'mail_read' });
    }
    async doDeleteMail({ fid, id, isThread, _account, directDelete = false }) {
        this.doClearSearchCache(_account);
        if (!id) {
            return this.deleteMailInFolder(fid, _account);
        }
        if (id && (fid === mailBoxOfDeleted.id || directDelete)) {
            const ids = typeof id === 'string' ? [id] : id;
            if (isThread) {
                const threadResult = await this.mailDbHanlder.getThreadMessageByThreadIds(ids, _account);
                if (threadResult && threadResult.threadMessages.length > 0) {
                    const threadMessageIds = threadResult.threadMessages.map(v => v.mid);
                    ids.push(...threadMessageIds);
                }
            }
            const key = 'deleteMail';
            const additionalParam = _account ? this.getAccountSession(_account) : undefined;
            const data = { ids, riskHitIntercept: true };
            const url = this.buildUrl(key, additionalParam, !!(additionalParam === null || additionalParam === void 0 ? void 0 : additionalParam._session), _account);
            return this.impl
                .post(url, data, this.getConfigForHttp(key, { url, data, _account }))
                .then(this.unpackData.bind(this))
                .then(res => {
                if (res.code === MailContentHandler.sOk) {
                    return {
                        succ: true,
                    };
                }
                this.notifyIntercept(res, { _account });
                return Promise.reject(this.getErrMsg(res.code));
            });
        }
        if (id) {
            return this.doMoveMail({
                id,
                fid: mailBoxOfDeleted.id,
                isThread,
                needFilter: false,
                _account,
                riskHitIntercept: true,
            });
        }
        throw new Error('参数错误');
    }
    deleteMailInFolder(fid, _account) {
        const key = 'emptyFolder';
        const additionalParam = _account ? this.getAccountSession(_account) : undefined;
        const url = this.buildUrl(key, additionalParam, !!(additionalParam === null || additionalParam === void 0 ? void 0 : additionalParam._session), _account);
        const data = { id: fid };
        return this.impl
            .post(url, data, this.getConfigForHttp(key, { url, data, _account }))
            .then(this.unpackData.bind(this))
            .then(res => {
            if (res.code === MailContentHandler.sOk) {
                return { succ: true };
            }
            this.notifyIntercept(res, { _account });
            return Promise.reject(this.getErrMsg(res.code));
        });
    }
    async updateMessageTags(params, isThread, _account) {
        var _a, _b, _c;
        const key = isThread ? 'updateThreadTags' : 'updateMessageTags';
        const url = this.buildUrl(key, undefined, undefined, _account);
        if (isThread) {
            params.ids = params.ids.filter(v => !v.includes('--'));
        }
        try {
            const ret = await this.impl.post(url, params, this.getConfigForHttp(key, { url, _account }));
            this.unpackData(ret);
            if (ret.status !== 200 || ((_a = ret.data) === null || _a === void 0 ? void 0 : _a.code) !== 'S_OK') {
                return Promise.reject(new Error(((_b = ret.data) === null || _b === void 0 ? void 0 : _b.message) || '操作失败'));
            }
            return Promise.resolve('');
        }
        catch (e) {
            return Promise.reject(new Error(((_c = e.data) === null || _c === void 0 ? void 0 : _c.message) || '操作失败'));
        }
    }
    async updateMessageInfos(item, _account) {
        var _a;
        try {
            const urlKey = 'updateMessageInfos';
            const url = this.buildUrl(urlKey, undefined, undefined, _account);
            const dt = Object.assign({}, item);
            const apiRet = await this.impl.post(url, dt, this.getConfigForHttp(urlKey, {
                url,
                data: item,
                method: 'post',
                _account,
            }));
            if (((_a = apiRet === null || apiRet === void 0 ? void 0 : apiRet.data) === null || _a === void 0 ? void 0 : _a.code) === MailAbstractHandler.sOk) {
                return Promise.resolve(true);
            }
            return Promise.reject();
        }
        catch (ex) {
            return Promise.reject(ex);
        }
    }
    async doMarkMail(conf) {
        const { mark, id, type, isThread = false, needFilter = false, deferParams, payload = {}, _account } = conf;
        console.log('[mail] mark mail network ' + id, mark, type);
        const ids = typeof id === 'string' ? [id] : id;
        const req = {
            ids,
            attrs: {},
            isThread,
            needFilter,
        };
        if (type === 'requestReadReceiptLocal') {
            return Promise.resolve({ succ: true });
        }
        if (type === 'memo') {
            const res = await this.updateMessageInfos({
                ids: [ids[0]],
                attrs: {
                    memo: payload.memo || '',
                },
            }, _account);
            return Promise.resolve({ succ: res === true });
        }
        switch (type) {
            case 'read':
                req.attrs.flags = { read: mark };
                break;
            case 'top':
                req.attrs.flags = { top: mark };
                break;
            case 'redFlag':
                req.attrs.label0 = mark ? 1 : 0;
                if (isThread) {
                    if (req.attrs.flags) {
                        req.attrs.flags = Object.assign(Object.assign({}, req.attrs.flags), { flagged: true });
                    }
                    else {
                        req.attrs.flags = { flagged: mark };
                    }
                }
                break;
            case 'preferred':
                req.attrs.preferred = mark ? 0 : -1;
                break;
            case 'spam':
                req.reportType = mark ? 'spam' : 'notspam';
                req.attrs.fid = mailBoxOfSpam.id;
                break;
            case 'defer':
                req.attrs.flags = { deferHandle: mark };
                if (mark) {
                    const deferTime = (deferParams === null || deferParams === void 0 ? void 0 : deferParams.deferTime) && (deferParams === null || deferParams === void 0 ? void 0 : deferParams.deferTime) > 0 ? deferParams === null || deferParams === void 0 ? void 0 : deferParams.deferTime : undefined;
                    req.attrs.defer = deferTime ? moment(deferTime).format('YYYY-MM-DD HH:mm:ss') : '';
                    req.attrs.deferNotice = (deferParams === null || deferParams === void 0 ? void 0 : deferParams.deferNotice) || false;
                }
                break;
            default:
                throw new Error('接口请求有误');
        }
        return this.modifyMail(req, _account);
    }
    doMoveMail({ id, fid, isThread, needFilter, _account }) {
        this.doClearSearchCache(_account);
        return this.modifyMail({
            ids: typeof id === 'string' ? [id] : id,
            attrs: {
                fid,
            },
            isThread,
            needFilter,
            _account,
            riskHitIntercept: true,
        }, _account);
    }
    doCompleteTrustMail(id) {
        return this.modifyMail({
            ids: typeof id === 'string' ? [id] : id,
            attrs: {
                flags: {
                    suspiciousSpam: false,
                },
            },
        });
    }
    doReportOrTrustMail(id, fid, spamType, isTread, _account) {
        if (isTread) {
            return Promise.reject(new Error('Not Support Report Or Trust Thread Mail'));
        }
        return this.modifyMail({
            ids: typeof id === 'string' ? [id] : id,
            attrs: {
                fid,
            },
            isThread: isTread,
            reportType: spamType !== undefined ? 'spam' : 'notspam',
            spamType,
        }, _account);
    }
    async modifyMail(req, _account) {
        if (req.needFilter) {
            await this.filterRequest(req);
        }
        if (!req.ids || req.ids.length === 0) {
            return Promise.resolve({
                succ: true,
            });
        }
        const isCorpMail = this.systemApi.getIsCorpMailMode();
        if (!isCorpMail && req.isThread) {
            req._account = undefined;
            const url = this.buildUrl('updateThreadInfo', undefined, undefined, _account);
            const threadReq = this.buildThreadMailUpdateReq(req);
            return this.impl
                .post(url, threadReq, {
                url,
                cachePolicy: 'noCache',
                contentType: 'json',
            })
                .then(this.unpackData.bind(this))
                .then(res => {
                if (res.code === MailContentHandler.sOk) {
                    return {
                        succ: true,
                    };
                }
                return Promise.reject(new Error((res === null || res === void 0 ? void 0 : res.code) + ''));
            });
        }
        const key = 'updateMail';
        let additionalParam;
        if (req._account) {
            additionalParam = this.getAccountSession(req._account);
        }
        if (_account) {
            additionalParam = this.getAccountSession(_account);
        }
        const url = this.buildUrl(key, additionalParam, !!(additionalParam === null || additionalParam === void 0 ? void 0 : additionalParam._session), _account);
        req.isThread = undefined;
        return this.impl
            .post(url, req, this.getConfigForHttp(key, {
            url,
            data: req,
            noErrorMsgEmit: true,
            _account,
        }))
            .then(this.unpackData.bind(this))
            .then(res => {
            if (res.code === MailContentHandler.sOk) {
                return {
                    succ: true,
                };
            }
            this.notifyIntercept(res, req);
            return Promise.reject(new Error((res === null || res === void 0 ? void 0 : res.code) + ''));
        });
    }
    notifyIntercept(res, req) {
        if (res.code === ErrResult.FA_RISK_HIT_INTERRUPT.code) {
            this.eventApi.sendSysEvent({
                eventName: 'RiskHitInterrupt',
                eventData: {
                    code: res.code,
                    operate: res.operate,
                    url: res.url,
                },
                _account: req._account,
            });
        }
    }
    buildThreadMailUpdateReq(req) {
        const baseReq = { ids: req.ids.filter(id => !id.includes('--')) };
        const attrs = {};
        if (req.attrs.fid !== undefined) {
            attrs.fid = req.attrs.fid;
        }
        if (req.attrs.label0 !== undefined) {
            attrs.label0 = req.attrs.label0;
        }
        if (req.attrs.flags !== undefined) {
            attrs.flags = req.attrs.flags;
        }
        return Object.assign(Object.assign({}, baseReq), { attrs });
    }
    async filterRequest(req) {
        const result = await this.doListMailBoxEntities({
            mids: req.ids,
            count: req.ids.length,
            ignoreContact: true,
            checkType: req.isThread ? 'checkThread' : 'normal',
            _account: req._account,
        }, true);
        const res = Array.isArray(result) ? result : result.data;
        const map = {};
        res.forEach(it => {
            map[it.id] = it.entry;
        });
        req.ids = req.ids.filter(it => {
            var _a;
            if (map[it]) {
                if (req.attrs.label0 !== undefined) {
                    return req.attrs.label0 === 1 ? map[it].mark !== 'redFlag' : map[it].mark === 'redFlag';
                }
                if (req.attrs.fid) {
                    return req.attrs !== map[it].folder;
                }
                if (((_a = req.attrs.flags) === null || _a === void 0 ? void 0 : _a.read) !== undefined) {
                    return req.attrs.flags.read ? map[it].readStatus === 'unread' : map[it].readStatus === 'read';
                }
            }
            return false;
        });
    }
    genMailWrapper(content, forward) {
        const sender = this.buildEmailContent(content.sender.contactItem.contactItemVal, content.sender.contact.contact.contactName);
        const receiver = content.receiver.reduce((prs, cur) => {
            const idx = MailOperationHandler.TypeIdxMap.get(cur.mailMemberType) || 0;
            const pr = prs[idx];
            const s = pr + (pr.length === 0 ? '' : ' , ') + this.buildEmailContent(cur.contactItem.contactItemVal, cur.contact.contact.contactName);
            prs[idx] = s;
            return prs;
        }, ['', '', '']);
        const quoteId = forward ? 'isForwardContent' : 'isReplyContent';
        const startStr = content.entry.writeLetterProp === 'forwardAsAttach' ? '<div class="pre-mail-content" style=\'display:none\'>' : '<div class="pre-mail-content">';
        const nReplayMap = this.mailConfApi.getConfigByNreplay();
        const timeZone = this.mailConfApi.getTimezone();
        const sendTime = dayjs(this.systemApi.getDateByTimeZone((content === null || content === void 0 ? void 0 : content.entry.sendTime) || 0, timeZone, true)).format('YYYY-MM-DD HH:mm:ss');
        const tzLang = this.mailConfApi.isReplyHeaderEnglish() ? 'en' : 'zh';
        const systemTimezone = this.systemApi.getSystemTimeZone(tzLang);
        const suffix = (systemTimezone === null || systemTimezone === void 0 ? void 0 : systemTimezone.value) ? `(${systemTimezone.value})` : '';
        const defaultSeparateLine = this.storeApi.getSync('defaultSeparateLine').data || '0';
        let blockquoteStyle = 'PADDING-LEFT: 1ex; BORDER-LEFT: #ccc 1px solid; margin: 0;';
        if (defaultSeparateLine === '0')
            blockquoteStyle = 'margin: 0;';
        return {
            start: startStr +
                this.contentBlockLine(3) +
                "<div id='" +
                quoteId +
                "' style='" +
                blockquoteStyle +
                "'>" +
                "<div style='color: #7d8085'>" +
                (forward ? nReplayMap.fw : nReplayMap.original) +
                ':</div>' +
                "<ul style='color: #7d8085; font-size:12px; padding-left: 20px'>" +
                '<li>' +
                nReplayMap.from +
                '：' +
                sender +
                '</li>' +
                '<li>' +
                nReplayMap.date +
                '：' +
                sendTime +
                suffix +
                '</li>' +
                '<li>' +
                nReplayMap.to +
                '：' +
                (receiver[0] ? receiver[0] : '') +
                '</li>' +
                '<li>' +
                nReplayMap.cc +
                '：' +
                (receiver[1] ? receiver[1] : '') +
                '</li>' +
                '<li>' +
                nReplayMap.subject +
                '：' +
                this.htmlApi.encodeHtml(content.entry.title) +
                '</li>' +
                '</ul>',
            end: '</div></div>',
        };
    }
    async handleRepliedResp(res, content) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        const { _account, isTpMail, owner, receiver: orgReceiver } = content;
        const orgToReceiver = orgReceiver.filter(it => it.mailMemberType === 'to').map(it => { var _a, _b; return (_b = (_a = it.contact) === null || _a === void 0 ? void 0 : _a.contact) === null || _b === void 0 ? void 0 : _b.accountName; });
        if (res.code === MailContentHandler.sOk) {
            const con = ((_a = res.var) === null || _a === void 0 ? void 0 : _a.content) || content.entry.content.content;
            content.entry.content = {
                content: con,
                contentId: '',
                contentLen: con.length,
            };
            content.entry.title = ((_b = res.var) === null || _b === void 0 ? void 0 : _b.subject) || content.entry.title;
            content._id = (_c = res.var) === null || _c === void 0 ? void 0 : _c.id;
            if ((_d = res.var) === null || _d === void 0 ? void 0 : _d.attachments) {
                const attachments = this.transAttachmentToResponseAttachment((_e = res.var) === null || _e === void 0 ? void 0 : _e.attachments);
                attachments === null || attachments === void 0 ? void 0 : attachments.forEach((it) => {
                    it._account = content._account;
                });
                const MailFileAttach = this.handleAttachment(attachments, content.id, {
                    forWrite: true,
                    isTpMail,
                    owner,
                    colleagueAccId: (_f = content === null || content === void 0 ? void 0 : content.tpMailInfo) === null || _f === void 0 ? void 0 : _f.colleagueAccId,
                }) || [];
                MailFileAttach.forEach((_, index) => {
                    var _a, _b;
                    if (content.entry.attachment && (_ === null || _ === void 0 ? void 0 : _.fileName) === ((_a = content.entry.attachment[index]) === null || _a === void 0 ? void 0 : _a.fileName) && ((_b = content.entry.attachment[index]) === null || _b === void 0 ? void 0 : _b.filePreviewUrl)) {
                        _.filePreviewUrl = content.entry.attachment[index].filePreviewUrl;
                    }
                });
                content.entry.attachment = MailFileAttach;
            }
            if (content.entry.writeLetterProp === 'reply' || content.entry.writeLetterProp === 'replyAll') {
                content.entry.attachment = (content.entry.attachment || []).filter((att) => (att === null || att === void 0 ? void 0 : att.inlined) === true);
            }
            if (((_g = res.var) === null || _g === void 0 ? void 0 : _g.priority) || ((_h = res.var) === null || _h === void 0 ? void 0 : _h.priority) === 0) {
                content.entry.priority = (_j = res.var) === null || _j === void 0 ? void 0 : _j.priority;
            }
            const user = this.systemApi.getCurrentUser(_account);
            if (!user) {
                this.eventApi.sendSimpleSysEvent('logout');
                throw new Error('not login , why?');
            }
            const currentUserMailList = this.getCurrentUserMailList({ _account });
            const senderMail = (_m = (_l = (_k = content === null || content === void 0 ? void 0 : content.sender) === null || _k === void 0 ? void 0 : _k.contact) === null || _l === void 0 ? void 0 : _l.contact) === null || _m === void 0 ? void 0 : _m.accountName;
            const isReplyAll = content.entry.writeLetterProp === 'replyAll' || content.entry.writeLetterProp === 'replyAllWithAttach';
            const receiver = [];
            if (!(isReplyAll && currentUserMailList.has(senderMail))) {
                const contacts = content.receiver.concat(content.sender);
                const memberType = ['to', 'cc', 'bcc'];
                const notExistMails = {
                    to: [],
                    cc: [],
                    bcc: [],
                };
                memberType.forEach((type) => {
                    let rev;
                    if (res.var) {
                        rev = res.var[type];
                    }
                    if (rev) {
                        rev.forEach((_user) => {
                            if (_user) {
                                const ret = {
                                    origin: [_user],
                                    parsed: [],
                                    type,
                                };
                                const email = this.contactHandler.handleEmailListStringToParsedContent(_user, ret);
                                if (email.parsed.length) {
                                    const emailStr = email.parsed[0].email;
                                    for (let i = 0; i < contacts.length; i++) {
                                        if (contacts[i].contact.contact.accountName === emailStr) {
                                            const onConcat = cloneDeep(contacts[i]);
                                            onConcat.mailMemberType = type;
                                            receiver.push(onConcat);
                                            break;
                                        }
                                        else if (i === contacts.length - 1) {
                                            notExistMails[type].push(emailStr);
                                        }
                                    }
                                }
                            }
                        });
                    }
                });
                const emails = [...notExistMails.to, ...notExistMails.cc, ...notExistMails.bcc];
                const emailRes = await this.contactApi.doGetContactByEmailFilter({ emails, _account });
                const emailsMap = {
                    to: notExistMails.to,
                    cc: notExistMails.cc,
                    bcc: notExistMails.bcc,
                };
                Object.keys(emailsMap).forEach(mailType => {
                    notExistMails[mailType].forEach(emailKey => {
                        const model = emailRes[emailKey];
                        if (model) {
                            receiver.push(this.contactHandler.transContactModel2MailContactModel(model, mailType));
                        }
                        else {
                            receiver.push(this.buildRawContactItem({
                                item: '',
                                email: emailKey,
                                name: '',
                                type: mailType,
                            }, _account));
                        }
                    });
                });
                content.receiver = receiver;
            }
            if (isReplyAll) {
                const _receiver = [];
                content.receiver.forEach(item => {
                    var _a, _b, _c, _d;
                    const email = ((_b = (_a = item === null || item === void 0 ? void 0 : item.contact) === null || _a === void 0 ? void 0 : _a.contact) === null || _b === void 0 ? void 0 : _b.displayEmail) || ((_d = (_c = item === null || item === void 0 ? void 0 : item.contact) === null || _c === void 0 ? void 0 : _c.contact) === null || _d === void 0 ? void 0 : _d.accountName);
                    const needFilterMyMail = currentUserMailList.has(email);
                    if (!needFilterMyMail) {
                        _receiver.push(item);
                    }
                });
                content.receiver = _receiver;
            }
            if (isReplyAll) {
                const ReplyAllContact = this.storeApi.getSync('ReplyAllContact', { noneUserRelated: true }).data || '0';
                if (ReplyAllContact === '1') {
                    orgToReceiver.forEach(email => {
                        const targetItem = content.receiver.find(_item => { var _a, _b; return ((_b = (_a = _item === null || _item === void 0 ? void 0 : _item.contact) === null || _a === void 0 ? void 0 : _a.contact) === null || _b === void 0 ? void 0 : _b.accountName) === email; });
                        if (targetItem) {
                            targetItem.mailMemberType = 'to';
                        }
                    });
                }
            }
            return content;
        }
        return Promise.reject(this.getErrMsg(res.code));
    }
    getCurrentUserMailList(params) {
        var _a, _b;
        const { current = true, alias = true, _account } = params || {};
        const currentUser = this.systemApi.getCurrentUser(_account);
        const currentUserMail = current && (currentUser === null || currentUser === void 0 ? void 0 : currentUser.id) ? [currentUser === null || currentUser === void 0 ? void 0 : currentUser.id] : [];
        const currentUserAliasMail = alias && ((_a = currentUser === null || currentUser === void 0 ? void 0 : currentUser.prop) === null || _a === void 0 ? void 0 : _a.accountAlias) ? (_b = currentUser === null || currentUser === void 0 ? void 0 : currentUser.prop) === null || _b === void 0 ? void 0 : _b.accountAlias : [];
        const agent = _account && this.accountApi.getAgentEmailByEmail(_account);
        const agentEmail = agent ? [agent] : [];
        return new Set([...currentUserMail, ...currentUserAliasMail, ...agentEmail]);
    }
    requestForward(content) {
        const { _account } = content;
        const wrapper = this.genMailWrapper(content, true);
        const key = 'forwardMail';
        const url = this.buildUrl(key, undefined, undefined, _account);
        const data = {
            mode: 'quote',
            attrs: {
                subject: this.mailConfApi.getForwardStyle(content.entry.title) + content.entry.title,
            },
            ids: [content.id],
            quoteHTMLStart: wrapper.start,
            quoteHTMLEnd: wrapper.end,
        };
        return this.impl
            .post(url, data, Object.assign(Object.assign({}, this.getConfigForHttp(key, { data, url })), { _account }))
            .then(this.unpackData.bind(this))
            .then(res => this.handleRepliedResp(res, content));
    }
    subRequestForward(content) {
        const { owner, tpMailInfo } = content;
        const _account = this.generateAcc(content);
        const { colleagueAccId, type: tpType, refId } = tpMailInfo || {};
        const wrapper = this.genMailWrapper(content, true);
        const key = 'forwardMail';
        const node = this.systemApi.getCurrentNode();
        let type;
        if (tpType === 'CUSTOMER') {
            type = 'conversation';
        }
        else if (tpType === 'LEADS') {
            type = 'hint';
        }
        else {
            type = '';
        }
        const url = this.buildUrl(key, { followee: owner || '', node, subEmail: owner || '', colleagueAccId: colleagueAccId || '', type, refId: String(refId) }, undefined, _account, process.env.BUILD_ISEDM ? 'getSubMailNew' : 'getLxSubMailNew');
        const data = {
            mode: 'quote',
            attrs: {
                subject: this.mailConfApi.getForwardStyle(content.entry.title) + content.entry.title,
            },
            ids: [content.id],
            quoteHTMLStart: wrapper.start,
            quoteHTMLEnd: wrapper.end,
        };
        return this.impl
            .post(url, data, Object.assign(Object.assign({}, this.getConfigForHttp(key, { data, url })), { timeout: 2 * 60 * 1000 }))
            .then(this.unpackSubData.bind(this))
            .then(res => this.handleRepliedResp(res, content));
    }
    requestForwardAsAttach(content) {
        const { _account, entry } = content;
        const { id, asAttachIds } = entry;
        content.entry.content.content = '';
        content.entry.title = this.mailConfApi.getForwardStyle(content.entry.title) + content.entry.title;
        const currentUser = this.systemApi.getCurrentUser(_account);
        const urlBase = this.systemApi.getAccountUrl('mailOperation', _account);
        const req = {
            action: 'forward',
            l: 'read',
            sid: (currentUser === null || currentUser === void 0 ? void 0 : currentUser.sessionId) || '',
            func: 'mbox:forwardMessages',
        };
        const data = {
            mode: 'attach',
            attrs: {
                account: `${currentUser === null || currentUser === void 0 ? void 0 : currentUser.id}`,
                isHtml: true,
                content: '',
            },
            ids: asAttachIds || [id],
            supportTNEF: true,
        };
        const url = this.impl.buildUrl(urlBase, req);
        return this.impl
            .post(url, data, this.getConfigForHttp('forwardMail', { data, url, _account }))
            .then(this.unpackData.bind(this))
            .then(res => this.handleRepliedResp(res, content))
            .then((content) => {
            content.entry.title = this.mailConfApi.getForwardStyle(content.entry.title) + content.entry.title;
            return content;
        });
    }
    subRequestForwardAsAttach(content) {
        const { entry, owner, tpMailInfo } = content;
        const _account = this.generateAcc(content);
        const { colleagueAccId, type: tpType, refId } = tpMailInfo || {};
        const { id, asAttachIds } = entry;
        content.entry.content.content = '';
        content.entry.title = this.mailConfApi.getForwardStyle(content.entry.title) + content.entry.title;
        const currentUser = this.systemApi.getCurrentUser(_account);
        const urlBase = this.systemApi.getAccountUrl(process.env.BUILD_ISEDM ? 'getSubMailNew' : 'getLxSubMailNew', _account);
        const node = this.systemApi.getCurrentNode();
        let type;
        if (tpType === 'CUSTOMER') {
            type = 'conversation';
        }
        else if (tpType === 'LEADS') {
            type = 'hint';
        }
        else {
            type = '';
        }
        const req = {
            action: 'forward',
            l: 'read',
            sid: (currentUser === null || currentUser === void 0 ? void 0 : currentUser.sessionId) || '',
            func: 'mbox:forwardMessages',
            followee: owner || '',
            node,
            subEmail: owner || '',
            colleagueAccId: colleagueAccId || '',
            type,
            refId,
        };
        const data = {
            mode: 'attach',
            attrs: {
                account: `${currentUser === null || currentUser === void 0 ? void 0 : currentUser.id}`,
                isHtml: true,
                content: '',
                subject: content.entry.title,
            },
            ids: asAttachIds || [id],
            supportTNEF: true,
        };
        const url = this.impl.buildUrl(urlBase, req);
        return this.impl
            .post(url, data, this.getConfigForHttp('forwardMail', { data, url, timeout: 2 * 60 * 1000 }))
            .then(this.unpackSubData.bind(this))
            .then(res => this.handleRepliedResp(res, content))
            .then((content) => {
            content.entry.title = this.mailConfApi.getForwardStyle(content.entry.title) + content.entry.title;
            return content;
        });
    }
    requestDelivery(id, bcc, _account) {
        const key = 'forwardMail';
        const url = this.buildUrl(key, undefined, undefined, _account);
        const data = {
            mode: 'transmit',
            attrs: {
                bcc,
                saveSentCopy: true,
                account: _account,
            },
            ids: [id],
            returnInfo: false,
            action: 'deliver',
        };
        return this.impl
            .post(url, data, this.getConfigForHttp(key, { data, url, _account }))
            .then(this.unpackData.bind(this))
            .then(res => {
            if (res && res.code === (MailAbstractHandler.sOk || MailAbstractHandler.SuccessCode)) {
                return Promise.resolve(true);
            }
            return Promise.resolve(false);
        })
            .catch(err => {
            console.log('[mail] requestDelivery failed:', err);
            return Promise.reject(err);
        });
    }
    requestDeliveryWm(params) {
        const { mid, showOnlyInProcess, _account, sid, node } = params || {};
        const key = 'getMailDeliveryDetailWm';
        const url = this.impl.buildUrl(this.systemApi.getUrl(key), { sid, node, mid, showOnlyInProcess });
        const data = {};
        return this.impl
            .get(url, data, {
            url,
            data,
            cachePolicy: 'noCache',
            noEnqueue: true,
            contentType: 'json',
            _account,
        })
            .then(this.unpackData.bind(this))
            .then(res => {
            if (res && res.code == 0) {
                return Promise.resolve(res.data);
            }
            return Promise.reject(new Error());
        })
            .catch(err => {
            console.log('[mail] requestDeliveryWm failed:', err);
            return Promise.reject(err);
        });
    }
    doAbortPastingAttachment(id) {
        if (this.pastingLoopMap.get(id)) {
            this.pastingLoopMap.delete(id);
        }
        return { success: true };
    }
    async writeMailCopyAttach(params) {
        const { _account, id } = params || {};
        const url = this.impl.buildUrl(this.systemApi.getUrl('copyAttach'), Object.assign({}, params));
        const config = { cachePolicy: 'noCache', noEnqueue: true, contentType: 'json', _account };
        this.pastingLoopMap.set(id, 0);
        try {
            const getRes = await this.impl.get(url, Object.assign({}, params), config);
            if (this.pastingLoopMap.get(id) === undefined) {
                return {
                    success: false,
                    message: '用户取消',
                };
            }
            const res = this.unpackData(getRes);
            if (!(res === null || res === void 0 ? void 0 : res.data)) {
                this.doAbortPastingAttachment(id);
                return { success: false, message: '生成链接失败' };
            }
            const { status, message: msg, url: link, key } = (res === null || res === void 0 ? void 0 : res.data) || {};
            if (link && status === 'success') {
                this.doAbortPastingAttachment(id);
                return {
                    success: true,
                    data: link,
                };
            }
            if (status === 'pending') {
                const loopRes = await this.loopCheckCopyAttachStatus(Object.assign(Object.assign({}, params), { key }));
                this.doAbortPastingAttachment(id);
                return loopRes;
            }
            this.doAbortPastingAttachment(id);
            return {
                success: false,
                message: msg || '生成链接失败',
            };
        }
        catch (error) {
            this.doAbortPastingAttachment(id);
            return {
                success: false,
                message: '生成链接失败',
            };
        }
    }
    async loopCheckCopyAttachStatus(params) {
        return new Promise((resolve, reject) => {
            this.checkCopyAttachStatus({ params, sucFun: resolve, failFun: reject });
        })
            .then(data => data)
            .catch(data => data);
    }
    async checkCopyAttachStatus(paramsObj) {
        const { params, sucFun, failFun } = paramsObj;
        const { _account, id } = params || {};
        if (this.pastingLoopMap.get(id) === undefined) {
            return { success: false, message: '用户取消' };
        }
        const url = this.impl.buildUrl(this.systemApi.getUrl('copyAttachStatus'), Object.assign({}, params));
        const config = { cachePolicy: 'noCache', noEnqueue: true, contentType: 'json', _account };
        try {
            const getRes = await this.impl.get(url, Object.assign({}, params), config);
            if (this.pastingLoopMap.get(id) === undefined) {
                return { success: false, message: '用户取消' };
            }
            const res = this.unpackData(getRes);
            const curTime = this.pastingLoopMap.get(id) + 1;
            this.pastingLoopMap.set(id, curTime);
            if (!(res === null || res === void 0 ? void 0 : res.data)) {
                failFun({
                    success: false,
                    message: '生成链接失败',
                });
                return;
            }
            const { status, message: msg, url: link } = (res === null || res === void 0 ? void 0 : res.data) || {};
            if (link && status === 'success') {
                sucFun({
                    success: true,
                    data: link,
                });
                return;
            }
            if (status === 'pending') {
                let delaytime = 1.5 * 1000;
                if (curTime >= 120) {
                    delaytime = 30 * 1000;
                }
                setTimeout(() => {
                    this.checkCopyAttachStatus({ params, sucFun, failFun });
                }, delaytime);
                return;
            }
            failFun({
                success: false,
                message: msg || '生成链接失败',
            });
            return;
        }
        catch (error) {
            failFun({
                success: false,
                message: '生成链接失败',
            });
        }
    }
    distributeMailWm(params) {
        const { mid, _account, account, flags, to, sid, node } = params || {};
        const key = 'distributeMailWm';
        const url = this.impl.buildUrl(this.systemApi.getUrl(key), {
            sid,
            node,
        });
        const data = {
            mid,
            account,
            flags,
            to,
        };
        return this.impl
            .post(url, data, {
            url,
            data,
            cachePolicy: 'noCache',
            noEnqueue: true,
            contentType: 'json',
            _account,
        })
            .then(this.unpackData.bind(this))
            .then(res => {
            if (res && res.code === 0) {
                return Promise.resolve(true);
            }
            return Promise.reject(new Error());
        })
            .catch(err => {
            console.log('[mail] distributeMailWm failed:', err);
            return Promise.reject(err);
        });
    }
    getOthersSubMailbox(account, _account) {
        const key = 'getOthersSubMailbox';
        const url = this.impl.buildUrl(this.systemApi.getUrl(key), { account });
        const data = { account };
        return this.impl
            .get(url, data, {
            url,
            data,
            cachePolicy: 'noCache',
            noEnqueue: true,
            contentType: 'json',
            _account,
        })
            .then(this.unpackData.bind(this))
            .then(res => {
            if (res && (res === null || res === void 0 ? void 0 : res.code) == 0) {
                return Promise.resolve(res.data);
            }
            return Promise.reject(new Error());
        })
            .catch(err => {
            console.log('[mail] getOthersSubMailbox failed:', err);
            return Promise.reject(err);
        });
    }
    getOthersSubMailboxV2(account, _account) {
        const key = 'getOthersSubMailboxV2';
        const url = this.impl.buildUrl(this.systemApi.getUrl(key), { account });
        const data = { account };
        return this.impl
            .get(url, data, {
            url,
            data,
            cachePolicy: 'noCache',
            noEnqueue: true,
            contentType: 'json',
            _account,
        })
            .then(this.unpackData.bind(this))
            .then(res => {
            if (res && (res === null || res === void 0 ? void 0 : res.code) == 0) {
                return Promise.resolve(res.data);
            }
            return Promise.reject(new Error());
        })
            .catch(err => {
            console.log('[mail] getOthersSubMailboxV2 failed:', err);
            return Promise.reject(err);
        });
    }
    requestReply(content, all, withAttachments) {
        const { _account } = content;
        const wrapper = this.genMailWrapper(content);
        const key = 'replyMail';
        const url = this.buildUrl(key, undefined, undefined, _account);
        let data = Object.assign(Object.assign({ mode: 'quote', attrs: {
                subject: this.mailConfApi.getReplayStyle(content.entry.title) + content.entry.title,
            }, id: content.id, toAll: all }, (all ? { dontCcDelegatedAddress: true } : {})), { withAttachments: !!withAttachments, quoteHTMLStart: wrapper.start, quoteHTMLEnd: wrapper.end });
        if (content.isDecrypted && content.entry.encpwd) {
            data = Object.assign(Object.assign({}, data), { decryptPassword: content.entry.encpwd || '' });
        }
        return this.impl
            .post(url, data, Object.assign(Object.assign({}, this.getConfigForHttp(key, { data, url })), { _account }))
            .then(this.unpackData.bind(this))
            .then(res => this.handleRepliedResp(res, content))
            .catch(err => {
            const { code } = err || {};
            let message = '回复失败';
            if (code) {
                const errObj = ErrResult[code];
                if (errObj) {
                    message = errObj.content || errObj.title;
                }
            }
            this.eventApi.sendSysEvent({
                eventName: 'writePageDataExchange',
                eventData: Object.assign(Object.assign({}, content), { failMsg: message }),
                eventStrData: 'createFail',
                _account: content._account,
            });
            return Promise.reject('requestReply error');
        });
    }
    generateAcc(mail) {
        let { _account, mailFrom, isTpMail, mainAccount } = mail;
        if (isTpMail && mailFrom === 'relatedEmail')
            _account = mainAccount;
        return _account;
    }
    subRequestReply(content, all, withAttachments) {
        const { owner, tpMailInfo } = content;
        const _account = this.generateAcc(content);
        const { colleagueAccId, type: tpType, refId } = tpMailInfo || {};
        const wrapper = this.genMailWrapper(content);
        const key = 'replyMail';
        const node = this.systemApi.getCurrentNode();
        let type;
        if (tpType === 'CUSTOMER') {
            type = 'conversation';
        }
        else if (tpType === 'LEADS') {
            type = 'hint';
        }
        else {
            type = '';
        }
        const url = this.buildUrl(key, { followee: owner || '', node, subEmail: owner || '', colleagueAccId: colleagueAccId || '', refId: String(refId), type }, undefined, _account, process.env.BUILD_ISEDM ? 'getSubMailNew' : 'getLxSubMailNew');
        let data = Object.assign(Object.assign({ mode: 'quote', attrs: {
                subject: this.mailConfApi.getReplayStyle(content.entry.title) + content.entry.title,
            }, id: content.id, toAll: all }, (all ? { dontCcDelegatedAddress: true } : {})), { withAttachments: !!withAttachments, quoteHTMLStart: wrapper.start, quoteHTMLEnd: wrapper.end });
        if (content.isDecrypted && content.entry.encpwd) {
            data = Object.assign(Object.assign({}, data), { decryptPassword: content.entry.encpwd || '' });
        }
        return this.impl
            .post(url, data, Object.assign(Object.assign({}, this.getConfigForHttp(key, { data, url })), { timeout: 2 * 60 * 1000 }))
            .then(this.unpackSubData.bind(this))
            .then(res => this.handleRepliedResp(res, content));
    }
    requestEdit(mailContentModel, draft) {
        const { _account } = mailContentModel;
        const key = draft ? 'editDraft' : 'editMail';
        const url = this.buildUrl(key, undefined, undefined, _account);
        const data = { id: mailContentModel.id };
        return this.impl
            .post(url, data, this.getConfigForHttp(key, {
            data,
            url,
            _account,
        }))
            .then(this.unpackData.bind(this))
            .then((res) => this.handleRepliedResp(res, mailContentModel));
    }
    contentBlockLine(num) {
        const alignMap = {
            JustifyLeft: 'left',
            JustifyCenter: 'center',
            JustifyRight: 'right',
            JustifyFull: 'justify',
        };
        let defaultFontFamily = this.storeApi.getSync('defaultFontFamily').data;
        defaultFontFamily = defaultFontFamily || 'Source Han Sans';
        const defaultFontFamilyStyle = `font-family:${defaultFontFamily};`;
        let defaultFontSize = this.storeApi.getSync('defaultFontSize').data || '14px';
        if (!/px$/.test(defaultFontSize)) {
            defaultFontSize += 'px';
        }
        const defaultFontSizeStyle = `font-size:${defaultFontSize};`;
        const defaultFontColor = this.storeApi.getSync('defaultColor').data;
        const defaultDir = this.storeApi.getSync('defaultDir').data;
        const defaultAlign = this.storeApi.getSync('defaultAlign').data;
        const defaultFontColorStyle = defaultFontColor ? `color:${defaultFontColor};` : '';
        const defaultAlignStyle = defaultAlign && !defaultDir ? `text-align:${alignMap[defaultAlign]};` : '';
        const attrDir = defaultDir ? `dir='${defaultDir}'` : '';
        let defaultLineHeight = this.storeApi.getSync('defaultLineHeight').data;
        defaultLineHeight = defaultLineHeight || '1.5';
        const defaultLineHeightStyle = `line-height:${defaultLineHeight};`;
        this.defaultStyle = `${defaultFontFamilyStyle}${defaultFontSizeStyle}${defaultLineHeightStyle}
      ${defaultFontColorStyle}${defaultAlignStyle}`;
        let res = '';
        for (let i = 0; i < num; i++) {
            res += `<div ${attrDir} style='${this.defaultStyle}' data-mce-style='${this.defaultStyle}'><br></div>`;
        }
        return res;
    }
    initModel(param) {
        console.log('[mail]******** call init model:', param);
        const { extraData, _account, owner, writeType, colleagueAccId = '', isTpMail, mailFrom, tpType, tpRefId } = param;
        const contractItemByEmail = param.contact && param.contact.length > 0 ? this.contactHandler.getContractItemByEmail(param.contact, 'to', _account) : Promise.resolve([]);
        const ccContactItemByEmail = param.ccContact && param.ccContact.length > 0 ? this.contactHandler.getContractItemByEmail(param.ccContact, 'cc', _account) : Promise.resolve([]);
        const bccContactItemByEmail = param.bccContact && param.bccContact.length > 0 ? this.contactHandler.getContractItemByEmail(param.bccContact, 'bcc', _account) : Promise.resolve([]);
        const signaturePromise = param.writeType !== 'editDraft' && param.writeType !== 'edit'
            ? this.mailSigApi.doGetDefaultSign(false, param.writeType, _account)
            : Promise.resolve({ enable: false, content: '' });
        if (!param.id) {
            const mailContentModel = this.buildEmptyMailEntryModel(param);
            return Promise.all([contractItemByEmail, ccContactItemByEmail, bccContactItemByEmail, signaturePromise]).then((r) => {
                const res = r[0];
                const resCC = r[1];
                const resBCC = r[2];
                const sig = r[3];
                res.forEach(it => {
                    if (it && it.contactItem.contactItemVal && it.contactItem.contactItemVal.length > 0) {
                        mailContentModel.receiver.push(it);
                    }
                });
                resCC.forEach(it => {
                    if (it && it.contactItem.contactItemVal && it.contactItem.contactItemVal.length > 0) {
                        mailContentModel.receiver.push(it);
                    }
                });
                resBCC.forEach(it => {
                    if (it && it.contactItem.contactItemVal && it.contactItem.contactItemVal.length > 0) {
                        mailContentModel.receiver.push(it);
                    }
                });
                if (sig && sig.enable) {
                    let contentCombine = this.contentBlockLine(4);
                    if (sig.content) {
                        contentCombine += sig.content;
                    }
                    mailContentModel.entry.content.content = this.htmlApi.mergeHtmlStr(mailContentModel.entry.content.content, contentCombine);
                }
                console.log('[mail]***** write mail model:', mailContentModel);
                if (!mailContentModel._account) {
                    mailContentModel._account = _account || '';
                }
                return mailContentModel;
            });
        }
        const isTpmail = isTpMail && (mailFrom === 'subordinate' || mailFrom === 'relatedEmail');
        if (writeType === 'replyAllAsNew') {
            this.mailApi.getMailContentInDb(param.id, false, _account);
            const mailContentPromise = this.mailApi.doGetMailContent(param.id, true, false, undefined, { _account });
            const buildParams = Object.assign({}, param);
            delete buildParams.id;
            const mailContentModel = this.buildEmptyMailEntryModel(buildParams);
            return Promise.all([mailContentPromise, signaturePromise]).then((r) => {
                var _a, _b;
                const cont = r[0];
                const sig = r[1];
                if (cont) {
                    const { sender, receiver } = cont;
                    const [originalTo, originalCc, originalBcc] = [[], [], []];
                    (receiver || []).forEach((it) => {
                        const { mailMemberType } = it;
                        if (mailMemberType === 'to') {
                            originalTo.push(it);
                        }
                        if (mailMemberType === 'cc') {
                            originalCc.push(it);
                        }
                        if (mailMemberType === 'bcc') {
                            originalBcc.push(it);
                        }
                    });
                    const senderMail = (_b = (_a = sender === null || sender === void 0 ? void 0 : sender.contact) === null || _a === void 0 ? void 0 : _a.contact) === null || _b === void 0 ? void 0 : _b.accountName;
                    const currentUserMailList = this.getCurrentUserMailList({ _account });
                    if (currentUserMailList.has(senderMail)) {
                        const to = [...originalTo];
                        const cc = [...originalCc];
                        const bcc = [...originalBcc];
                        mailContentModel.receiver = [...to, ...cc, ...bcc];
                    }
                    else {
                        const to = [Object.assign(Object.assign({}, sender), { mailMemberType: 'to' })];
                        const cc = [...originalTo.map(item => (Object.assign(Object.assign({}, item), { mailMemberType: 'cc' }))), ...originalCc];
                        mailContentModel.receiver = [...to, ...cc];
                    }
                }
                if (sig && sig.enable) {
                    let contentCombine = this.contentBlockLine(4);
                    if (sig.content) {
                        contentCombine += sig.content;
                    }
                    mailContentModel.entry.content.content = this.htmlApi.mergeHtmlStr(mailContentModel.entry.content.content, contentCombine);
                }
                mailContentModel.entry.writeLetterProp = param === null || param === void 0 ? void 0 : param.writeType;
                mailContentModel.originMailId = param.id;
                console.log('[mail]***** replyAllAsNew model:', mailContentModel);
                if (!mailContentModel._account) {
                    mailContentModel._account = _account || '';
                }
                return mailContentModel;
            });
        }
        const getMailContentPromise = () => {
            if (param.mustExist)
                return Promise.resolve(undefined);
            const isForwardAsAttach = ['forwardAsAttach'].some(writeType => writeType === param.writeType);
            if (isForwardAsAttach) {
                const temp = this.buildEmptyMailEntryModel(param);
                if (isTpmail) {
                    temp.isTpMail = param.isTpMail;
                    temp.mailFrom = param.mailFrom;
                    temp.owner = param.owner;
                    temp.tpMailInfo = {
                        colleagueAccId: param.colleagueAccId,
                        belongEmail: param.owner,
                        refId: param.tpRefId,
                        type: param.tpType,
                    };
                }
                return Promise.resolve(temp);
            }
            if (isTpmail) {
                return this.mailApi.doGetTpMailContent({ mid: param.id, owner, colleagueAccId, mailFrom, type: tpType, refId: tpRefId });
            }
            return this.mailApi.getMailContentInDb(param.id, false, _account);
        };
        return (getMailContentPromise()
            .then(re => {
            if (re) {
                return re;
            }
            return this.doGetMailContent(param.id, { _account, mustExist: param.mustExist, mustExistInfo: param.mustExistInfo });
        })
            .catch(reason => {
            console.warn(reason);
            return this.doGetMailContent(param.id, { _account, mustExist: param.mustExist, mustExistInfo: param.mustExistInfo });
        })
            .then((originModel) => {
            var _a;
            let mailContentModel = originModel;
            if (param.writeType === 'editDraft') {
                try {
                    mailContentModel = cloneDeep(originModel);
                }
                catch (error) {
                    console.error('[mail] cloneDeep error:', error);
                    mailContentModel = originModel;
                }
            }
            if (param.withoutPlaceholder) {
                mailContentModel.entry.withoutPlaceholder = param.withoutPlaceholder;
            }
            if ((mailContentModel === null || mailContentModel === void 0 ? void 0 : mailContentModel.isEncryptedMail) && ((_a = param.writeType) === null || _a === void 0 ? void 0 : _a.includes('reply'))) {
                return this.mailApi.insertDecryptedContent(mailContentModel, mailContentModel.id);
            }
            return mailContentModel;
        })
            .then((mailContentModel) => {
            console.log('initModel mailContentModel', mailContentModel);
            mailContentModel.entry.writeLetterProp = param.writeType;
            mailContentModel.entry.title = this.htmlApi.decodeHtml(mailContentModel.entry.title);
            let mailEntryModelPromise;
            if (param.writeType === 'forward') {
                if (param.mustExist) {
                    const mustExistSubj = mailContentModel.entry.title;
                    if (!mustExistSubj.includes('Fw:') && !mustExistSubj.includes('fw:')) {
                        mailContentModel.entry.title = 'Fw:' + mustExistSubj;
                    }
                    mailEntryModelPromise = Promise.resolve(mailContentModel);
                }
                else {
                    mailEntryModelPromise = isTpmail ? this.subRequestForward(mailContentModel) : this.requestForward(mailContentModel);
                }
            }
            else if (param.writeType === 'forwardAsAttach') {
                mailEntryModelPromise = isTpmail ? this.subRequestForwardAsAttach(mailContentModel) : this.requestForwardAsAttach(mailContentModel);
            }
            else if (param.writeType === 'reply') {
                if (param.mustExist) {
                    const mustExistSubj = mailContentModel.entry.title;
                    if (!mustExistSubj.includes('Re:') && !mustExistSubj.includes('re:')) {
                        mailContentModel.entry.title = 'Re:' + mustExistSubj;
                    }
                    mailEntryModelPromise = Promise.resolve(mailContentModel);
                }
                else {
                    mailEntryModelPromise = isTpmail ? this.subRequestReply(mailContentModel, false) : this.requestReply(mailContentModel, false);
                }
            }
            else if (param.writeType === 'replyAll') {
                mailEntryModelPromise = isTpmail ? this.subRequestReply(mailContentModel, true) : this.requestReply(mailContentModel, true);
            }
            else if (param.writeType === 'replyWithAttach') {
                mailEntryModelPromise = isTpmail ? this.subRequestReply(mailContentModel, false, true) : this.requestReply(mailContentModel, false, true);
            }
            else if (param.writeType === 'replyAllWithAttach') {
                mailEntryModelPromise = isTpmail ? this.subRequestReply(mailContentModel, true, true) : this.requestReply(mailContentModel, true, true);
            }
            else if (param.writeType === 'edit') {
                mailEntryModelPromise = this.requestEdit(mailContentModel, false);
            }
            else if (param.writeType === 'editDraft') {
                mailEntryModelPromise = this.requestEdit(mailContentModel, true);
            }
            else {
                mailEntryModelPromise = Promise.resolve(mailContentModel);
            }
            return Promise.all([mailEntryModelPromise, contractItemByEmail, signaturePromise]);
        })
            .then(async (rs) => {
            var _a, _b, _c, _d;
            console.log('[mail]***** write mail model:', rs);
            let mailContentModel = rs[0];
            const res = rs[1];
            const sig = rs[2];
            let { content } = mailContentModel.entry.content;
            if (content.includes('paste-img-title') || content.includes('paste-img-reload')) {
                content = content.replace(/paste-img-((title)|(reload))/g, '');
            }
            mailContentModel.entry.content.isHtml = true;
            if (sig && sig.enable && param.writeType !== 'editDraft' && param.writeType !== 'edit') {
                content = this.htmlApi.mergeHtmlStr(`${this.contentBlockLine(4)}${sig.content}`, content);
            }
            const con = this.buildInitContent(param);
            content = this.htmlApi.mergeHtmlStr(con, content);
            mailContentModel.entry.content.content = content;
            mailContentModel.entry.writeLetterProp = param === null || param === void 0 ? void 0 : param.writeType;
            const user = this.systemApi.getCurrentUser(_account);
            if (!user) {
                this.eventApi.sendSimpleSysEvent('logout');
                throw new Error('not login , why?');
            }
            const mainAndAliaAccounts = await this.mailConfApi.getMailSenderInfo();
            const defAccount = mainAndAliaAccounts.find(item => item.isDefault);
            const mainAccount = mainAndAliaAccounts.find(item => item.isMainEmail);
            if ((mainAccount === null || mainAccount === void 0 ? void 0 : mainAccount.id) === (user === null || user === void 0 ? void 0 : user.id) && defAccount) {
                mailContentModel.aliasSender = {
                    name: '',
                    id: defAccount.id,
                    nickName: defAccount.senderName,
                    mailEmail: defAccount.mailEmail,
                    domain: '',
                };
            }
            mailContentModel.sender = this.buildRawContactItem({
                item: '',
                name: (user === null || user === void 0 ? void 0 : user.nickName) || ' ',
                email: (user === null || user === void 0 ? void 0 : user.id) || '',
                type: '',
                id: (_b = (_a = user === null || user === void 0 ? void 0 : user.contact) === null || _a === void 0 ? void 0 : _a.contact) === null || _b === void 0 ? void 0 : _b.id,
            }, _account);
            if (param.writeType !== 'forwardAsAttach' && res && res.length > 0) {
                res.forEach(it => {
                    if (it && it.contactItem.contactItemVal && it.contactItem.contactItemVal.length > 0) {
                        mailContentModel.receiver.push(it);
                    }
                });
            }
            mailContentModel.originMailId = param.id;
            await this.modelHandler.handleMailContentReplace(mailContentModel, 'writeLetterSinceExist', param.writeType);
            if (param.writeType === 'forwardAsAttach') {
                this.modelHandler.saveEntryToStore(mailContentModel, undefined, ((_c = mailContentModel === null || mailContentModel === void 0 ? void 0 : mailContentModel.entry) === null || _c === void 0 ? void 0 : _c.attachment) || undefined);
            }
            else {
                mailContentModel = this.modelHandler.updateLocalContent(mailContentModel);
            }
            console.log('[mail]***** final write mail model:', mailContentModel, param === null || param === void 0 ? void 0 : param.writeType);
            if ((param === null || param === void 0 ? void 0 : param.writeType) === 'editDraft' && extraData && (extraData === null || extraData === void 0 ? void 0 : extraData.draftVersionId)) {
                const mergedModel = await this.localDraftMerge(extraData.draftVersionId, mailContentModel);
                return mergedModel;
            }
            if (!mailContentModel._account) {
                mailContentModel._account = _account || '';
            }
            if (mailContentModel.isTpMail && mailContentModel.mailFrom === 'relatedEmail') {
                mailContentModel._account = (_d = this.systemApi.getCurrentUser()) === null || _d === void 0 ? void 0 : _d.id;
            }
            if (!Array.isArray(mailContentModel.entry.attachment)) {
                mailContentModel.entry.attachment = [];
            }
            return mailContentModel;
        })
            .catch(reason => {
            console.log('[mail] initModel failed:', reason);
            return Promise.reject(this.commonCatch(reason));
        }));
    }
    async localDraftMerge(draftVersionId, remoteModel) {
        const curDraft = await this.db.getById(mailUnfinishedMailTable, draftVersionId);
        console.log('curDraftcurDraft', curDraft, remoteModel);
        const newModel = Object.assign({}, remoteModel);
        const { cid, entry: { content: draftContent, title: draftTitle, attachment: draftAttachment }, sender: draftSender, receiver: draftReceiver, } = curDraft;
        const { entry: { content: remoteContent, attachment: remoteAttachment }, } = remoteModel;
        const finalAttachment = remoteAttachment || [];
        let finalContent = draftContent.content || '';
        try {
            if (draftContent.content && remoteContent.content) {
                if (/data-timedate="\d+"/g.test(draftContent.content)) {
                    const parser1 = new DOMParser();
                    const doc1 = parser1.parseFromString(draftContent.content, 'text/html');
                    const allImg1 = doc1.getElementsByTagName('img');
                    const parser2 = new DOMParser();
                    const doc2 = parser2.parseFromString(remoteContent.content, 'text/html');
                    const allImg2 = doc2.getElementsByTagName('img');
                    Array.from(allImg1).forEach((item1, index1) => {
                        const { dataset: { timedate }, } = item1;
                        if (timedate) {
                            const findImg = Array.from(allImg2).find(item2 => { var _a; return ((_a = item2 === null || item2 === void 0 ? void 0 : item2.dataset) === null || _a === void 0 ? void 0 : _a.timedate) === timedate; });
                            if (findImg) {
                                doc1.getElementsByTagName('img')[index1].src = findImg.src;
                            }
                        }
                    });
                    finalContent = doc1.documentElement.innerHTML;
                }
            }
        }
        catch (error) {
            console.log('内联附件替换失败', error);
            finalContent = remoteContent.content || '';
        }
        const filteredDraftAttachment = (draftAttachment || []).filter(item => {
            const { deleted, type, fileStatus } = item;
            if (deleted)
                return false;
            if (type === 'upload' && fileStatus !== 'uploaded')
                return false;
            return true;
        });
        const unableRecoverAttCount = filteredDraftAttachment.length - finalAttachment.length;
        return Object.assign(Object.assign({}, newModel), { sender: draftSender, receiver: draftReceiver, entry: Object.assign(Object.assign({}, newModel.entry), { content: Object.assign(Object.assign({}, draftContent), { content: finalContent }), title: draftTitle, attachment: finalAttachment, attachmentCount: finalAttachment.length }), unableRecoverAttCount: unableRecoverAttCount > 0 ? unableRecoverAttCount : 0, recoverCid: cid });
    }
    buildEmailContent(email, name) {
        if (!email) {
            return '';
        }
        return name ? `${name}&lt;<a href="mailto:${email}">${email}</a>&gt;` : email;
    }
    async doWriteMailToContact(contact, _account, writeWay) {
        const params = {
            contact: contact || [],
            writeType: 'common',
            mailType: 'common',
            _account,
            writeWay,
        };
        return this.callWriteLetterFunc(params);
    }
    async doWriteMailFromLink(contact, title, originContent, _account, otherParams) {
        const params = Object.assign({ contact: contact || [], title: title || '', originContent: originContent || '', withoutPlaceholder: !!originContent, writeType: 'common', mailType: 'common', _account }, otherParams);
        return this.callWriteLetterFunc(params);
    }
    async doWriteMailToServer() {
        const deviceInfo = await api.getSystemApi().getDeviceInfo();
        const title = `【问题反馈】网易灵犀${capitalize(deviceInfo._system)}端${config('version')}`;
        const originContent = await this.getMailCont(deviceInfo);
        const contact = ['kf@office.163.com'];
        const ccContact = ['feedback_desktop@office.163.com'];
        const params = {
            title,
            contact,
            ccContact,
            originContent,
            writeType: 'common',
            mailType: 'common',
            extraOperate: 'questionApply',
        };
        this.callWriteLetterFunc(params);
    }
    async doWriteMailToWaimaoServer() {
        const deviceInfo = await api.getSystemApi().getDeviceInfo();
        const title = `【问题反馈】网易外贸通${capitalize(deviceInfo._system)}端${config('version')}`;
        const originContent = await this.getMailCont(deviceInfo);
        const contact = ['kf@office.163.com'];
        const ccContact = ['feedback_waimao@office.163.com'];
        const params = {
            title,
            contact,
            ccContact,
            originContent,
            writeType: 'common',
            mailType: 'common',
            extraOperate: 'questionApply',
        };
        this.callWriteLetterFunc(params);
    }
    async getMailCont(deviceInfo) {
        const getNetCond = async () => {
            var _a;
            if ((_a = window === null || window === void 0 ? void 0 : window.electronLib) === null || _a === void 0 ? void 0 : _a.appManage) {
                const path = (config('host') || '');
                const host = new URL(path).hostname;
                try {
                    const res = await window.electronLib.appManage.getNetState(host);
                    const post = {
                        host,
                        electron_online: navigator.onLine,
                        dns_lookup_v4: res[0],
                        dns_lookup_v6: res[1],
                        dns_resolveAny: res[2],
                        traceroute: res[3],
                    };
                    return JSON.stringify(post);
                }
                catch (error) {
                    return '';
                }
            }
            return '';
        };
        const currentUser = this.systemApi.getCurrentUser();
        const netCond = await getNetCond();
        return `您好，请填写以下信息，能帮助我们更快的了解您的困扰<br/><br/>
      <strong>问题说明（可包含截图）：</strong><br/><br/>
      <strong>复现步骤：</strong><br/><br/>
      <strong>账号名：</strong>${currentUser === null || currentUser === void 0 ? void 0 : currentUser.id}<br/><br/>
      <strong>问题发生时间点：</strong>一分钟前？<br/><br/>
      以下信息能帮助我们了解问题<strong>（请勿删除）：</strong><br/>
      设备信息：<br/>${JSON.stringify(deviceInfo)}<br/>
      构建信息：<br/>${config('version') + '-' + config('versionTime')}<br/>
      ${netCond ? `网络监控：<br/>${JSON.stringify(netCond)}` : ''}
    `;
    }
    doMarkMailPerferred(email, priority, op, _account) {
        const key = 'markPreferred';
        const url = this.buildUrl(key, undefined, undefined, _account);
        const data = { email, priority, op };
        return this.impl
            .post(url, data, this.getConfigForHttp(key, { data, url, _account }))
            .then(this.unpackData.bind(this))
            .then(res => {
            if (res.code === MailContentHandler.sOk) {
                return {
                    succ: true,
                };
            }
            return Promise.reject(this.getErrMsg(res.code));
        });
    }
    doMarkMailInfFolder(mark, fid, isTread = false, _account) {
        const key = 'markAllMail';
        const url = this.buildUrl(key, undefined, undefined, _account);
        const data = isTread ? { fid, read: mark, threads: isTread } : { fid, read: mark };
        return this.impl
            .post(url, data, Object.assign(Object.assign({}, (this.getConfigForHttp(key, { data, url }) || {})), { _account }))
            .then(this.unpackData.bind(this))
            .then(res => {
            if (res.code === MailContentHandler.sOk) {
                return {
                    succ: true,
                };
            }
            return Promise.reject(this.getErrMsg(res.code));
        });
    }
    doGetAllComposingMailId() {
        const ids = [];
        this.actions.writingMailIds.forEach(it => {
            ids.push(parseInt(it.replace(MailModelHandler.mailPrefix, ''), 10));
        });
        return ids;
    }
    doWithdrawMail(mid, tid, _account) {
        console.log('[mail] withdraw mail for' + mid, tid);
        const key1 = 'withdrawSending';
        const url = this.buildUrl(key1, { action: 'recallMessage' }, undefined, _account);
        const data2 = tid ? { mid, tid } : { mid };
        return this.impl
            .post(url, data2, Object.assign(Object.assign({}, (this.getConfigForHttp(key1, { url, data: data2 }) || {})), { _account }))
            .then(this.unpackData.bind(this))
            .then((res) => {
            const key = 'checkPostMail';
            const url = this.buildUrl(key, undefined, undefined, _account);
            const data1 = { mid };
            if (res.code === 'FA_UNSUPPORT_RECALL') {
                this.eventApi.sendSysEvent({
                    eventName: 'error',
                    eventLevel: 'error',
                    eventStrData: '',
                    eventData: {
                        popupType: 'toast',
                        popupLevel: 'info',
                        title: getIn18Text('CHEHUISHIBGYJWFCHRYY6'),
                        content: getIn18Text('CIYOUJIANWUFABEICHE'),
                        code: 'PARAM.ERR',
                    },
                    eventSeq: 0,
                });
                return Promise.reject(getIn18Text('CHEHUISHIBGYJWFCHRYY6'));
            }
            const apiResponsePromise = this.impl.post(url, data1, this.getConfigForHttp(key, { url, data: data1 }));
            return apiResponsePromise.then(this.unpackData.bind(this)).then((status) => {
                if (status.code === 'FA_MAIL_NOT_FOUND') {
                    this.eventApi.sendSysEvent({
                        eventName: 'error',
                        eventLevel: 'error',
                        eventStrData: '',
                        eventData: {
                            popupType: 'toast',
                            popupLevel: 'info',
                            title: getIn18Text('CHEHUISHIBAI'),
                            content: getIn18Text('YOUJIANBUCUNZAI，WU'),
                            code: 'PARAM.ERR',
                        },
                        eventSeq: 0,
                    });
                    return Promise.reject('邮件不存在，无法撤回');
                }
                if (status.code === 'FA_UNSUPPORT_RECALL') {
                    this.eventApi.sendSysEvent({
                        eventName: 'error',
                        eventLevel: 'error',
                        eventStrData: '',
                        eventData: {
                            popupType: 'toast',
                            popupLevel: 'info',
                            title: getIn18Text('CHEHUISHIBAI'),
                            content: getIn18Text('CIYOUJIANWUFABEICHE'),
                            code: 'PARAM.ERR',
                        },
                        eventSeq: 0,
                    });
                    return Promise.reject('此邮件无法被撤回，可能原因为该邮件暂未发送成功');
                }
                if (status.code === 'FA_MAIL_EXPIRED') {
                    this.eventApi.sendSysEvent({
                        eventName: 'error',
                        eventLevel: 'error',
                        eventStrData: '',
                        eventData: {
                            popupType: 'toast',
                            popupLevel: 'info',
                            title: getIn18Text('CHEHUISHIBAI'),
                            content: getIn18Text('YOUJIANYICHAOGUOKECHA'),
                            code: 'PARAM.ERR',
                        },
                        eventSeq: 0,
                    });
                    return Promise.reject('邮件已超过可查询撤回状态时间');
                }
                if (status.code === MailOperationHandler.sOk) {
                    if (res && res.code === MailContentHandler.sOk && res.var) {
                        const result = {
                            status: res.code,
                            detail: [],
                            tid: tid || '',
                        };
                        const data = res.var.recallresult;
                        const contactList = [];
                        if (data) {
                            Object.keys(data).forEach(i => {
                                if (i && Object.prototype.hasOwnProperty.apply(data, [i]) && typeof data[i] === 'number') {
                                    contactList.push(i);
                                    result.detail.push({
                                        result: data[i],
                                        email: i,
                                        mid,
                                    });
                                }
                            });
                        }
                        return this.contactHandler
                            .getContractItemByEmail(contactList, '')
                            .then((ret) => {
                            const contactMap = {};
                            if (ret && ret.length > 0) {
                                ret.forEach(it => {
                                    contactMap[it.contactItem.contactItemVal] = it.contact;
                                });
                            }
                            result.detail.forEach(it => {
                                it.contact = contactMap[it.email];
                                if (it.contact) {
                                    it.contactName = it.contact.contact.contactName;
                                    it.avatar = it.contact.contact.avatar || it.contact.contact.contactLabel;
                                }
                            });
                            return result;
                        })
                            .catch(reason => {
                            console.warn(reason);
                            return result;
                        });
                    }
                    return Promise.reject(this.getMailErrMsg(res));
                }
                return Promise.reject('未知发送状态');
            });
        });
    }
    async callWriteLetterFunc(params) {
        var _a;
        const { writeWay, optSenderStr, id: originId, writeType, _account, hideBack } = params;
        if (writeWay === 'newWebTab') {
            this.callWriteLetterWeb(params);
            return params;
        }
        const targetActions = (_a = this.mailApi.getActions({
            actions: this.actions,
            subActions: this.subActions,
        })) === null || _a === void 0 ? void 0 : _a.val;
        const isInSubWindow = !locationHelper.isMainPage();
        const inElectron = this.systemApi.isElectron() && window.electronLib;
        this.dataTracker.track('pcMail_view_writeMailPage');
        if (inElectron && isInSubWindow) {
            this.eventApi.sendSysEvent({
                eventName: 'openWritePageFromMain',
                eventData: params,
                eventSeq: -1,
                eventStrData: '',
                _account,
            });
            return {};
        }
        this.eventApi.sendSysEvent({
            eventName: 'writePageDataExchange',
            eventData: params,
            eventStrData: 'start',
        });
        if (params.appointAccount) {
            params._account = params.appointAccount;
        }
        if (params.mailFormClickWriteMail) {
            params._account = params.mailFormClickWriteMail;
        }
        trackApi.track('callWriteLetterFunc_params', {
            params: JSON.stringify(params),
        });
        const initModelPromise = this.mailApi.initModel(params);
        if (inElectron && writeWay === 'newWin') {
            const createWindowResPromise = this.systemApi.createWindow({ type: 'writeMail', manualShow: false });
            await Promise.all([createWindowResPromise, initModelPromise]).then((result) => {
                const res0 = Object.assign({}, result[0]);
                const res1 = Object.assign({}, result[1]);
                console.log('[mail] ******** write mail init model && create window return', result);
                if (res0 && res0.webId !== undefined) {
                    if (MailContentHandler.debugMailPopWindow) {
                        window.electronLib.windowManage.toggleDevTools(res0.winId);
                    }
                    const hintId = String(Date.now());
                    res1.extData = res1.extData ? Object.assign(Object.assign({}, res1.extData), { hintId }) : { hintId };
                    res1.optSenderStr = optSenderStr || '';
                    if (hideBack)
                        res1.hideBack = hideBack;
                    if (targetActions)
                        targetActions.mailParamMap[res0.webId] = res1;
                    if (targetActions && targetActions.paramDispatched.has(res0.webId)) {
                        this.sendDataToWritePage(res1, res0.webId, params);
                    }
                }
            });
        }
        else if (!this.systemApi.isInWebWorker()) {
            console.log('[mail] send write mail event', params);
            const timestamp = String(new Date().getTime());
            this.eventApi.sendSysEvent({
                eventName: 'preCreateWriteTab',
                eventData: {
                    tabTempId: timestamp,
                    originId,
                    writeType,
                    _account: params._account,
                },
            });
            await initModelPromise
                .then((res) => {
                res.optSenderStr = optSenderStr || '';
                this.sendDataToWritePage(Object.assign(Object.assign({}, res), { tabTempId: timestamp }), null, params);
            })
                .catch(error => {
                console.log('initModelError', error);
                this.eventApi.sendSysEvent({
                    eventName: 'destoryWriteTab',
                    eventData: {
                        tabTempId: timestamp,
                        originId,
                        writeType,
                    },
                });
            });
        }
        return params;
    }
    async callWriteLetterWeb(params) {
        try {
            const initRes = await this.mailApi.initModel(params);
            console.log('callWriteLetterWeb initModel', initRes);
            const { cid } = initRes;
            if (cid) {
                const targetUrl = `${this.systemApi.getContextPath()}/writeMail/?${getDingTalkSearchString(false, true)}type=initByCid&cid=${encodeURIComponent(cid)}`;
                this.systemApi.openNewWindow(targetUrl, false);
            }
        }
        catch (error) {
            console.log('callWriteLetterWeb error', error);
        }
    }
    sendDataToWritePage(eventData, eventTarget, params) {
        var _a, _b, _c;
        (_c = (_b = this.eventApi
            .sendSysEvent({
            eventName: 'writePageDataExchange',
            eventData,
            eventStrData: 'initData',
            eventTarget: eventTarget ? String(eventTarget) : undefined,
            _account: ((_a = params) === null || _a === void 0 ? void 0 : _a._account) || '',
        })) === null || _b === void 0 ? void 0 : _b.then(() => {
            console.log('写信初始化数据发送成功');
        })) === null || _c === void 0 ? void 0 : _c.catch(ex => {
            console.error(ex);
            this.errReportApi.doReportMessage({
                error: '写信数据发送失败：' + ex.message,
                data: params,
                id: eventData,
            });
        });
    }
    doSaveMailInitParamLocal(content) {
        this.modelHandler.saveInitModelToStore(content);
    }
    doDelMailInitParamLocal(content) {
        this.modelHandler.delInitModelToStore(content);
    }
    doLoadMailInitParamLocal(mid) {
        return this.modelHandler.loadInitModelToStore(mid);
    }
    doSaveMailLocal(content) {
        this.modelHandler.saveEntryToStore(content).then();
    }
    doGetReplayContentModel(content) {
        if (!content || !content.id || !content.writeType) {
            return Promise.reject('调用需要提供邮件id和发信类型');
        }
        return this.mailApi.initModel(content);
    }
    buildRawContactItem(item, _account) {
        return this.contactHandler.buildRawContactItem(item, _account);
    }
    transAttachmentToResponseAttachment(attachments) {
        const ret = [];
        if (attachments && attachments.length > 0) {
            attachments.forEach(it => {
                ret.push({
                    id: it.id,
                    inlined: it.inlined,
                    filename: it.displayName || it.name,
                    contentLength: it.size,
                });
            });
        }
        return ret;
    }
    async getTranslateContent(content, from, to, _account) {
        const url = this.systemApi.getUrl('getTranslateContentByHtml');
        const paramData = { q: content, from, to };
        console.log('getTranslateContent======data', paramData);
        const { data } = await this.impl.post(url, paramData, { dataType: 'jsonp', _account });
        if (data && data.code === 0 && data.data.translation[0]) {
            try {
                data.data.translation[0] = data.data.translation[0].replace(/nextSibling/g, 'nextElementSibling');
            }
            catch (_a) {
                console.log('translation=replace=defeated');
            }
        }
        return data;
    }
    async detectMailContentLang(content) {
        const url = this.systemApi.getUrl('detectMailContentLang');
        try {
            const { data } = await this.impl.post(url, {
                content,
            }, { contentType: 'json' });
            if (data && data.code === 0 && data.data) {
                return data.data;
            }
        }
        catch (error) {
            console.error('[mail_impl] detectMailContentLang error', error);
            return {
                detected: true,
                lang: 'en',
            };
        }
        return {
            detected: false,
            lang: '',
        };
    }
    async getEnglishGrammar(content, _account) {
        const url = this.systemApi.getUrl('getEnglishGrammar');
        const paramData = { q: content, grade: 'default' };
        const { data } = await this.impl.post(url, paramData, { contentType: 'json', _account });
        if (data && data.code === 0) {
            return JSON.parse(data === null || data === void 0 ? void 0 : data.data);
        }
        return null;
    }
    async syncTranslateContentToDb(mid, langType, conditions, _account) {
        return this.mailDbHanlder.syncTranslateContentToDb(mid, langType, conditions, _account);
    }
    async syncContentLangToDb(mid, originLang, _account) {
        return this.mailDbHanlder.syncContentLangToDb(mid, originLang, _account);
    }
}
MailOperationHandler.TypeIdxMap = new Map([
    ['to', 0],
    ['cc', 1],
    ['bcc', 2],
]);
